<template>
    <b-container>
        <b-row align-h="center">
            <b-col cols="12">
                <b-card class="shadow my-md-4 mt-4 mb-2">
                    <h4 class="text-center text-primary text-uppercase">
                        <u>Resumen: ID {{ details.id }}</u>
                    </h4>
                    <h5 class="text-center">Estado: {{ details.status_title }}</h5>
                </b-card>
            </b-col>
        </b-row>
        <b-row align-h="center">
            <b-col cols="12" md="6" class="pb-md-4 py-2">
                <b-card class="shadow h-100">
                    <b-table-simple stacked>
                        <b-tbody>
                            <b-tr>
                                <b-th class="text-center border-top-0">Datos del Enviador</b-th>
                                <b-td stacked-heading="Nombres">{{ details.sender.name }}</b-td>
                                <b-td stacked-heading="Apellidos">{{ details.sender.lname ? (details.sender.lname).replace(',', '') : '' }}</b-td>
                                <b-td stacked-heading="Documento">{{ details.sender.td }} {{ details.sender.nd }}</b-td>
                                <b-td stacked-heading="Email">{{ details.sender.email }}</b-td>
                                <b-td stacked-heading="Teléfono">{{ details.sender.mobile }}</b-td>
                                <b-td stacked-heading="Dirección">{{ details.sender.address }} {{ details.receiver.district }}</b-td>
                                <b-td stacked-heading="Ciudad">{{ details.sender.city }}</b-td>
                                <b-td stacked-heading="País">{{ details.country_send_text }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-card>
            </b-col>
            <b-col cols="12" md="6" class="pb-md-4 py-2">
                <b-card class="shadow h-100">
                    <b-table-simple stacked>
                        <b-tbody>
                            <b-tr>
                                <b-th class="text-center border-top-0">Datos del Destinatario</b-th>
                                <b-td stacked-heading="Nombres">{{ details.receiver.name }}</b-td>
                                <b-td stacked-heading="Apellidos">{{ details.receiver.lname ? (details.receiver.lname).replace(',', '') : '' }}</b-td>
                                <b-td stacked-heading="Documento">{{ details.receiver.td }} {{ details.receiver.nd }}</b-td>
                                <b-td stacked-heading="Email">{{ details.receiver.email }}</b-td>
                                <b-td stacked-heading="Teléfono">{{ details.receiver.mobile }}</b-td>
                                <b-td stacked-heading="Dirección">{{ details.receiver.address }} {{ details.receiver.district }}</b-td>
                                <b-td stacked-heading="Ciudad">{{ details.receiver.city }}</b-td>
                                <b-td stacked-heading="País">{{ details.country_receiver_text }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-card>
            </b-col>
            <b-col cols="12" md="6" class="pb-md-4 py-2">
                <b-card class="shadow h-100">
                    <b-table-simple stacked>
                        <b-tbody>
                            <b-tr>
                                <b-th class="text-center border-top-0">Detalles de la Transacción</b-th>
                                <b-td stacked-heading="Sessión ID">{{ details.session_id }}</b-td>
                                <b-td stacked-heading="Fecha/Hora">{{ new Date((''+details.date).replace(/ /g,"T")) | moment("DD/MM/YYYY hh:mm A") }}</b-td>
                                <b-td stacked-heading="Forma de Pago">{{ details.pay_method_text || details.payment_text }}</b-td>
                                <b-td stacked-heading="Valor Enviado">{{ Number(details.amount_send - details.fee).toLocaleString("en-US") + ' ' + details.currency_send }}</b-td>
                                <b-td stacked-heading="Comisión">{{ Number(details.fee_net).toLocaleString("en-US") + ' ' + details.currency_send }}</b-td>
                                <b-td stacked-heading="IVA">{{ Number(details.tax).toLocaleString("en-US") + ' ' + details.currency_send }}</b-td>
                                <b-td stacked-heading="Descuento" v-if="details.promo_code" class="text-success">
                                    <strong>- {{ Number(details.promo_discount_amount).toLocaleString("en-US") + ' ' + details.currency_send }}</strong>
                                    <small class="d-block">Código {{ details.promo_code }}</small>
                                </b-td>
                                <b-td stacked-heading="Valor Pagado">{{ Number(details.amount_send).toLocaleString("en-US") + ' ' + details.currency_send }}</b-td>
                                <b-td stacked-heading="Tasa de Conversión">{{details.rate < 1 ? Number(1/details.rate).toLocaleString("en-US", {maximumFractionDigits: 4}) : 1 }} {{ details.currency_send }} ► {{details.rate > 1 ? Number(details.rate).toLocaleString("en-US", {maximumFractionDigits: 4}) : 1 }} {{ details.currency_receiver }}</b-td>
                                <b-td stacked-heading="Valor Recibido">{{ Number(details.amount_receiver).toLocaleString("en-US") + ' ' + details.currency_receiver }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-card>
            </b-col>
            <b-col cols="12" md="6" class="pb-md-4 py-2">
                <b-card class="shadow h-100">
                    <b-table-simple stacked>
                        <b-tbody>
                            <b-tr>
                                <b-th class="text-center border-top-0">Detalles de Pago</b-th>
                                <b-td stacked-heading="Convenio" v-if="details.pin !== null && details.country_receiver === 'CO' && (details.pin).includes('-')">{{ ((details.pin).split('-'))[0] }}</b-td>
                                <b-td stacked-heading="PIN">{{ details.pin !== null && details.country_receiver === 'CO' && (details.pin).includes('-') ? ((details.pin).split('-'))[1] : details.pin }}</b-td>
                                <b-td stacked-heading="Banco" v-if="details.destiny_pay === 'Bank'">{{ details.bank_info?.name }}</b-td>
                                <b-td stacked-heading="Oficina" v-else>
                                    {{ details.office_info ? (details.office_info.name + ' (' + details.office_info.payer + ')') : '' }}
                                </b-td>
                                <b-td stacked-heading="Teléfono" v-if="details.destiny_pay === 'Cash'">{{ details.office_info?.phone }}</b-td>
                                <b-td stacked-heading="Dirección" v-if="details.destiny_pay === 'Cash'">{{ details.office_info?.address + ', ' + details.office_info?.city + (details.office_info?.state !== null ? ' - ' + details.office_info?.state : '') }}</b-td>
                                <b-td stacked-heading="Horario" v-if="details.destiny_pay === 'Cash'">{{ details.office_info?.open }}</b-td>
                                <b-td
                                    :stacked-heading="'Cuenta ' + (details.receiver.tc === 'Ahorros' ? 'de ' : '') + (details.receiver.tc || '')"
                                    v-else
                                >
                                    {{ details.receiver.tc === undefined ? '' : details.receiver.nc }}
                                </b-td>
                                <b-td stacked-heading="CBU" v-if="details.destiny_pay === 'Bank' && details.country_receiver === 'AR'">{{ details.receiver.details.cbu }}</b-td>
                                <b-td stacked-heading="CPF" v-if="details.destiny_pay === 'Bank' && details.country_receiver === 'BR'">{{ details.receiver.details.cpf }}</b-td>
                                <b-td stacked-heading="Agencia Bancaria" v-if="details.destiny_pay === 'Bank' && details.country_receiver === 'BR'">{{ details.receiver.details.nab }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-card>
            </b-col>
        </b-row>
        <div id="ticket">
            <div style="width: 280px; margin: 0; text-align: center;">
                <img :src="'/' + (partner && partner.logo ? partner.logo : 'img/logo_header.png')"
                     alt="logo partner" title="Logo Partner" style="max-width: 220px; padding-bottom: 12px;"/>
            </div>
            <p style="font-family: 'Trebuchet MS', Helvetica, sans-serif; text-align: center; width: 280px; margin: 0;">
                <strong><u>TICKET #{{ (details.id).toString().padStart(6, 0) }}</u></strong>
                <br><br>
                <span v-if="partner">{{partner.name}}</span>
                <br v-if="partner">
                <span v-if="partner">{{ partner.address + ' - ' }}{{ partner.city + ', ' }}{{ partner.country }}</span>
                <br v-if="partner"><br v-if="partner">
                <span style="text-transform: capitalize;">Cajero: {{ user.name ? (user.name).toLowerCase() : '' }}{{ user.lname ? ' ' + ((user.lname).replace(/,/g, '')).toLowerCase() : '' }}</span>
                <br>
                <span>{{ new Date() | moment("DD/MM/YYYY hh:mm:ss A") }}</span>
                <br><br>
                <strong v-if="details.pin !== null && details.country_receiver === 'CO' && (details.pin).includes('-')"><u>Convenio: {{ ((details.pin).split('-'))[0] }}</u></strong>
                <br v-if="details.pin !== null && details.country_receiver === 'CO' && (details.pin).includes('-')">
                <strong><u>PIN: {{ details.pin !== null && details.country_receiver === 'CO' && (details.pin).includes('-') ? ((details.pin).split('-'))[1] : details.pin }}</u></strong>
                <br><br>
                <span>Válido por 30 Días</span>
                <br><br>
            </p>
            <table style="font-family: 'Trebuchet MS', Helvetica, sans-serif; margin: 0; border-top: 1px solid black; border-collapse: collapse;">
                <thead>
                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;">
                    <th style="width: 120px; max-width: 120px;">Beneficiario</th>
                    <th style="width: 160px; max-width: 160px; text-transform: capitalize;">{{ details.rname ? (details.rname).toLowerCase() : '' }}</th>
                </tr>
                </thead>
                <tbody>
                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;" v-if="details.rdocument">
                    <td style="width: 120px; max-width: 120px;">Documento</td>
                    <td style="width: 160px; max-width: 160px;">{{ details.rdocument }}</td>
                </tr>
                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;" v-if="details.bank_info">
                    <td style="width: 120px; max-width: 120px;">Banco</td>
                    <td style="width: 160px; max-width: 160px;">{{ details.bank_info?.name }}</td>
                </tr>
                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;" v-if="details.receiver.tc">
                    <td style="width: 120px; max-width: 120px;">Tipo de Cuenta</td>
                    <td style="width: 160px; max-width: 160px;">{{ details.receiver.tc }}</td>
                </tr>
                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;" v-if="details.receiver.nc">
                    <td style="width: 120px; max-width: 120px;">Número de Cuenta</td>
                    <td style="width: 160px; max-width: 160px; word-break: break-all;">{{ details.receiver.nc }}</td>
                </tr>
                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;" v-if="details.office_info">
                    <td style="width: 120px; max-width: 120px;">Oficina</td>
                    <td style="width: 160px; max-width: 160px;">{{ details.office_info ? (details.office_info.payer + ' - ' + details.office_info.name) : '' }}</td>
                </tr>
                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;" v-if="details.office_info">
                    <td style="width: 120px; max-width: 120px;">Dirección</td>
                    <td style="width: 160px; max-width: 160px;">{{ details.office_info?.address + ' - ' + details.office_info?.city }}</td>
                </tr>
                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;">
                    <td style="width: 120px; max-width: 120px;">Valor Enviado</td>
                    <td style="width: 160px; max-width: 160px;">{{ details.amount_swc + ' ' + details.currency_send }}</td>
                </tr>
                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;">
                    <td style="width: 120px; max-width: 120px;">Comisión</td>
                    <td style="width: 160px; max-width: 160px;">{{ details.fee_net_text + ' ' + details.currency_send }}</td>
                </tr>
                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;">
                    <td style="width: 120px; max-width: 120px;">IVA</td>
                    <td style="width: 160px; max-width: 160px;">{{ details.tax_text + ' ' + details.currency_send }}</td>
                </tr>
                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;" v-if="details.promo_code">
                    <td style="width: 120px; max-width: 120px;"><strong>Descuento ({{ details.promo_code }})</strong></td>
                    <td style="width: 160px; max-width: 160px;"><strong>- {{ details.promo_discount_text + ' ' + details.currency_send }}</strong></td>
                </tr>
                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;">
                    <td style="width: 120px; max-width: 120px;">Valor Pagado</td>
                    <td style="width: 160px; max-width: 160px;">{{ details.amount_send_text + ' ' + details.currency_send }}</td>
                </tr>
                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;" v-if="details.pay_method_text">
                    <td style="width: 120px; max-width: 120px;">Forma de Pago</td>
                    <td style="width: 160px; max-width: 160px;">{{ details.pay_method_text }}</td>
                </tr>
                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;">
                    <td style="width: 120px; max-width: 120px;">Tipo de Cambio</td>
                    <td style="width: 160px; max-width: 160px;">{{ details.fx }}</td>
                </tr>
                </tbody>
                <tfoot>
                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;">
                    <th style="width: 120px; max-width: 120px;">Valor a Pagar</th>
                    <th style="width: 160px; max-width: 160px;">{{ details.amount_receiver_text + ' ' + details.currency_receiver }}</th>
                </tr>
                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;">
                    <th colspan="2"/>
                </tr>
                </tfoot>
            </table>
            <br>
            <br>
            <div style="text-align: center; font-family: 'Trebuchet MS', Helvetica, sans-serif; width: 280px; margin: 0;">
                <div style="margin: -2px 0 0; border: 1px solid #333;">
                    <p style="font-weight: 600; font-size: 16px; margin: 4px 0;">Depositante</p>
                    <p style="font-size: 16px; margin: 4px 0; text-transform: capitalize;">{{ details.sname ? (details.sname).toLowerCase() : '' }}</p>
                    <p style="margin: -2px 0 8px; font-size: 14px;">{{ details.sender.email ? (details.sender.email).toLowerCase() : '' }}</p>
                    <p style="margin: -2px 0 8px; font-size: 14px;">{{ details.country_send_text + ' => ' + details.country_receiver_text }}</p>
                </div>
                <br>
                <br>
                <p style="align-content: center; font-size: 16px;">
                    <b>__________________________</b>
                    <b>Firma</b>
                </p>
                <br>
                <p style="align-content: center; font-size: 16px;">
                    <b>¡GRACIAS POR PREFERIRNOS!</b>
                </p>
                <br>
                <br>
            </div>
        </div>
    </b-container>
</template>

<script>
import axios from "axios";

export default {
    name: "PartnerResult",
    props: [ 'user' ],
    data: () => ({
        loading: true,
        partner: {
            code: null,
            logo: null,
            name: null,
            address: null,
            city: null,
            country: null
        },
        details: {
            id: '',
            session_id: '',
            sender: {
                name: '',
                lname: '',
                td: '',
                nd: '',
                email: '',
                mobile: '',
                address: '',
                district: '',
                city: '',
                state: '',
                country: ''
            },
            receiver: {
                name: '',
                lname: '',
                td: '',
                nd: '',
                email: '',
                mobile: '',
                bank: '',
                tc: '',
                nc: '',
                address: '',
                district: '',
                city: '',
                state: '',
                country: ''
            },
            sname: '',
            sdocument: '',
            rname: '',
            rdocument: '',
            country_send_text: '',
            country_receiver_text: '',
            destiny_pay: '',
            office_info: {
                name: '',
                payer: ''
            },
            bank_info: {
                name: ''
            },
            amount_send: '',
            amount_send_text: '',
            amount_swc: '',
            currency_send: '',
            fee: '',
            fee_text: '',
            fee_net: '',
            fee_net_text: '',
            tax: '',
            tax_text: '',
            tax_rate: '',
            promo_code: null,
            promo_discount_amount: 0,
            promo_discount_text: '',
            fx_rate: '',
            amount_receiver: '',
            amount_receiver_text: '',
            currency_receiver: '',
            payment: '',
            payment_text: '',
            pay_method: '',
            pay_method_text: '',
            status_title: ''
        }
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'resultpage');
        this.getIni();
        const msg = this.$route.query.msg || null;
        const status = this.$route.query.status || null;
        if (msg && status) {
            this.getMsg(msg, status);
            this.$router.replace({ query: {} });
        }
    },
    methods: {
        getIni() {
            axios.get('/api/partner/request/result').then((res) => {
                console.log('/api/partner/request/result', res);
                if (res.data.status === 'success') {
                    this.partner = res.data.partner;
                    this.details = res.data.item;
                } else {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                    this.$router.push({ name: 'PartnerRequest' });
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.loading = false;
                setTimeout(this.print, 2000);
            });
        },
        getMsg(msg, status) {
            this.$root.$bvToast.toast(msg, {
                title: 'Notificación',
                headerClass: 'd-none',
                variant: status,
                toaster: 'b-toaster-top-right',
                autoHideDelay: 5000,
                solid: true,
                appendToast: true
            });
        },
        print() {
            let printContents = document.getElementById('ticket').innerHTML;
            let w = window.open('_', 'Imprimir Voucher');
            w.document.write(printContents);
            w.document.close(); // necessary for IE >= 10
            w.onload=function () { // necessary if the div contain images
                w.focus(); // necessary for IE >= 10
                w.print();
                w.close();
            };
        }
    }
}
</script>

<style scoped>
@media print {
    #ticket {}
}
@media screen {
    #ticket {
        display: none;
    }
}
</style>
